import { render, staticRenderFns } from "./onebox-login-business-sharedtoken_byfolder.vue?vue&type=template&id=5528683c&"
import script from "./onebox-login-business-sharedtoken_byfolder.vue?vue&type=script&lang=js&"
export * from "./onebox-login-business-sharedtoken_byfolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports